import Vue from 'vue';
import App from './App.vue';
import { createProvider } from './vue-apollo'
import 'jquery/dist/jquery.slim'
import 'bootstrap/dist/js/bootstrap.bundle'

Vue.config.productionTip = true;
import 'swiper/swiper-bundle.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'

new Vue({
    apolloProvider: createProvider(),
    render: h => h(App)
}).$mount('#app');